import axios from 'axios';
import { UserEntry } from '../../types/generated/userEntry';

export const fetchFlagAuditlog = async (
    featureFlagKey: string,
    toastText?: {
        onSuccessText?: string;
        onPendingText?: string;
    }
) =>
    axios
        .get(`/featureflag/features/auditlog/${featureFlagKey}`, {
            headers: {
                'Toast-Pending-Text': toastText?.onPendingText,
                'Toast-Success-Text': toastText?.onSuccessText,
            },
        })
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
